module.exports = __webpack_public_path__ + "img/bg_publi.47d90d81.jpg";